import { ChakraBaseProvider } from "@chakra-ui/react";

import Header from '../../header/components/Header';
import '../styles/layout.scss';
import claverTheme from './theme/claverTheme';
import useViewport from './Viewport';
import config from "../../../../../config/app-config";


export default function Layout(props) {

	const { width } = useViewport();
	const {pathname} = props.location  || {}

	// To determine whether it is DSR mode without admin header
	const isDsrMode = /^\/(dsr|pdsr|archived|edit|draft|template)/.test(pathname);
		

	function renderLayout(layoutWidth)  {
		// Consider getting mobile view value from redux state instead. 
		const {mobileWidthBreakpoint, tabletWidthBreakpoint} = config;
		if (layoutWidth <= mobileWidthBreakpoint) {    
			return (
				<div className="app-layout-mobile">
					<Header className="app-layout__header" displayMode='mobile'/>
					<main className="app-layout__content">{props.children.props.children}</main> 
					{/* // TODO: Refactor this */}
				</div>
			);

		} 
		else if (layoutWidth > mobileWidthBreakpoint && layoutWidth <= tabletWidthBreakpoint) {
			return (
				<div className="app-layout-mobile">
					<Header className="app-layout__header" displayMode='mobile'/>
					<main className="app-layout__content">{props.children.props.children}</main>
						{/* // TODO: Refactor this */}
				</div>
			);

		} 
		else
      if (layoutWidth > tabletWidthBreakpoint) {
			if (isDsrMode===true) {
				return (
					<div className="app-layout-new">
						<main className="app-layout__dsr_content">{props.children}</main>
					</div>
				);
			} 
			return (
				<div className="app-layout-new">
					<Header className="app-layout__header" displayMode=''/>
					<main className="app-layout__content">
						<div className="app-layout-new__content-display-optimization">
							{props.children}
						</div>
					</main>
				</div>
			);
		}

		else return null;
	};


		return (
			<ChakraBaseProvider theme={claverTheme}>
				{renderLayout(width)}
			</ChakraBaseProvider>
		);

	}

